// components/WishlistModal.jsx
import React, { useState } from 'react';
import constants from '../config/consts';
import '../styles/WishlistModal.css';
import { useWishlistContext } from '../context/WishlistContext';
import { useNavigate } from 'react-router-dom';

const WishlistModal = ({ onClose }) => {
  const { products, loading, removeItem, updateQuantity, total } = useWishlistContext();
  const navigate = useNavigate();

  const handleOrder = () => {
    // Здесь логика оформления заказа
    navigate('/buy')
    onClose();
  };

  return (
    <div className="wishlistModalOverlay" onClick={onClose}>
      <div className="wishlistModalContent" onClick={(e) => e.stopPropagation()}>
        <button className="closeModal" onClick={onClose}>×</button>
        <h3>Избранное</h3>
        {loading ? (
          <div className="loading">Загрузка...</div>
        ) : products.length === 0 ? (
          <p className="emptyWishlist">В избранном пока ничего нет</p>
        ) : (
          <>
            <div className="wishlistItems">
              {products.map(product => {
                const imageUrl = product.images?.split(',')[0] || product.preViewImg;
                return (
                  <div key={product._id} className="wishlistItem">
                    <img
                      src={`${constants.serverUrl}${imageUrl}`}
                      alt={product.title}
                      className="wishlistItemImage"
                    />
                    <div className="wishlistItemInfo">
                      <p className="wishlistItemTitle">{product.title}</p>
                      <p className="wishlistItemPrice">{product.price} ₽</p>
                      {product.isMany ? (
                        <div className="quantityControl">
                          <button
                            className="qtyBtn"
                            onClick={() => updateQuantity(product._id, product.quantity - 1)}
                            disabled={product.quantity <= 1}
                          >
                            −
                          </button>
                          <input
                            type="number"
                            className="qtyInput"
                            value={product.quantity}
                            min="1"
                            onChange={(e) => {
                              const val = parseInt(e.target.value, 10);
                              if (!isNaN(val) && val >= 1) {
                                updateQuantity(product._id, val);
                              }
                            }}
                          />
                          <button
                            className="qtyBtn"
                            onClick={() => updateQuantity(product._id, product.quantity + 1)}
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <p className="quantityStatic">1 шт.</p>
                      )}
                    </div>
                    <button
                      className="removeWishlistItem"
                      onClick={() => removeItem(product._id)}
                    >
                      ×
                    </button>
                  </div>
                );
              })}
            </div>
            <div className="wishlistFooter">
              <span className="wishlistTotal">Итого: {total} ₽</span>
              <button className="wishlistOrderButton" onClick={handleOrder}>
                Заказать
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WishlistModal;